export default "__VITE_ASSET__Bd7obLER__"